import "./Title.css";

export default function Title() {
    return (
        <div className="title-wrapper">
            <div className='title-name'>
                Menu
            </div>
        </div>
    );
}